import { render } from "./component-id-gk.vue?vue&type=template&id=a230390e"
import script from "./component-id-gk.vue?vue&type=script&setup=true&lang=js"
export * from "./component-id-gk.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-id-gk.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a230390e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a230390e', __exports__)) {
    api.reload('a230390e', __exports__)
  }
  
  module.hot.accept("./component-id-gk.vue?vue&type=template&id=a230390e", () => {
    api.rerender('a230390e', render)
  })

}


export default __exports__